import { addressInfoDisplayStyles } from "@insite/content-library/Components/AddressInfoDisplay";
import { css } from "styled-components";

addressInfoDisplayStyles.wrapper = {
    css: css`
        font-style: normal;
        font-size: 18px;
    `,
};